import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/layout/Header';
import NavigationButton from '../components/layout/Navigation';
import axios from 'axios';
import '../styles/Body.css';

const API = process.env.REACT_APP_API_BASE_URL;

const ContactUs = () => {
  const [aboutUs, setAboutUs] = useState(null);

  useEffect(() => {
    const fetchAboutUs = async () => {
      try {
        const res = await axios.get(`${API}/api/site-content/about-us/`);
        const items = Array.isArray(res.data) ? res.data : (res.data.results ? res.data.results : []);
        if (items.length > 0 && items[0]) {
          setAboutUs(items[0]);
        }
      } catch (err) {
        console.error('Error fetching about us in ContactUs:', err);
      }
    };
    fetchAboutUs();
  }, []);

  const rawWhatsapp = aboutUs?.whatsapp_number || '6285643848251';
  const whatsappLink = `https://wa.me/${rawWhatsapp.replace(/\D/g, '')}`;
  const displayWhatsapp = aboutUs?.whatsapp_number ? (aboutUs.whatsapp_number.startsWith('+') ? aboutUs.whatsapp_number : `+${aboutUs.whatsapp_number}`) : '+62 856-4384-8251';
  const officeAddress = aboutUs?.office_address || 'Jl. Tubagus Ismail Dalam No.19C dan bertempat di Dago, Kota Bandung, Jawa Barat';

  return (
    <div className="body">
      <Helmet>
        <meta name="description" content="Kontak BAE Community" />
        <meta property="og:title" content="Kontak BAE Community" />
        <meta property="og:description" content="Kontak BAE Community" />
        <meta property="og:image" content="%PUBLIC_URL%/images/web-thumbnail.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
      </Helmet>

      <Header />

      <div className="container mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold mb-4">Hubungi Kami</h1>
        
        <div className="bg-white rounded-lg shadow p-4 mb-4">
          <h2 className="text-xl font-semibold mb-2">{aboutUs?.title || 'BAE Community'}</h2>
          
          <div className="flex items-center mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
            <p className="text-gray-600">
              WhatsApp: <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="text-green-600 hover:underline">{displayWhatsapp}</a>
            </p>
          </div>

          <div className="flex items-start mb-3">
            <span className="material-icons text-gray-600 mr-2 text-xl">location_on</span>
            <p className="text-gray-600">
              Office: {officeAddress}
            </p>
          </div>
          <div className="iframe-container">
            <iframe title="Location of BAE Office" 
              className="flex items-center max-w-md mx-auto" 
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15844.263411318185!2d107.6122856!3d-6.882715!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e7f35c0b8b49%3A0xd610847fc7a8fd9e!2sRumah%20Kost%20Tubagus%20Ismail%20Bawah%2020%20Dipati%20Ukur%20Dago!5e0!3m2!1sen!2sid!4v1740895385622!5m2!1sen!2sid" height="500"></iframe>
          </div>
        </div>
      </div>
      <NavigationButton />
    </div>
  );
};

export default ContactUs;